import React, { useState } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { isValidElementType } from 'react-is';
import { getItem, KEYS } from '@storage';
import routes from '@routes';

const ProtectedRoute = ({ component: RouteComponent, ...routeProps }) => {
  const [isAuthenticated, setAuthenticated] = useState(
    !!getItem(KEYS.AUTH_TOKEN),
  );
  const [refreshTokenPersist, setRefreshTokenPersistance] = useState(
    !!getItem(KEYS.REFRESH_TOKEN),
  );

  if (isAuthenticated !== !!getItem(KEYS.AUTH_TOKEN)) {
    setAuthenticated(!!getItem(KEYS.AUTH_TOKEN));
  }

  if (refreshTokenPersist !== !!getItem(KEYS.REFRESH_TOKEN)) {
    setRefreshTokenPersistance(!!getItem(KEYS.REFRESH_TOKEN));
  }

  return (
    <Route
      {...routeProps}
      render={(props) =>
        isAuthenticated ? (
          <RouteComponent {...props} />
        ) : (
          <Redirect to={routes.auth.signIn} />
        )
      }
    />
  );
};

ProtectedRoute.propTypes = {
  // eslint-disable-next-line
  component: (props, propName) => {
    if (props[propName] && !isValidElementType(props[propName])) {
      return new Error(
        `Invalid prop 'component' supplied to 'Route': the prop is not a valid React component`,
      );
    }
  },
};

export default withRouter(ProtectedRoute);
